<template>
  <div
    :id="clickable ? buttonId : undefined"
    class="flex h-full flex-col overflow-hidden rounded-3xl border border-solid border-gray-500 bg-white transition-shadow"
    :class="[
      clickable &&
        'group cursor-pointer hover:shadow-card hover:shadow-blue-400_a3',
      hasShadow && 'shadow-card',
      hasMinHeight && 'min-h-[400px]',
    ]"
    :title="clickable ? title : ''"
    @click="handleClick"
  >
    <div class="flex grow flex-col justify-between p-4 tablet:p-5">
      <div
        class="flex h-full w-full flex-1 flex-col justify-between tablet:min-h-32"
      >
        <h3 class="text-h5 mb-2 truncate">
          {{ title }}
        </h3>

        <p class="truncate text-sm leading-6 text-gray-700">
          {{ description }}
        </p>

        <TheNuxtLink
          v-if="buttonUrl"
          ref="linkRef"
          :to="buttonUrl"
          class="hidden"
        >
          {{ buttonName }}
        </TheNuxtLink>
      </div>
    </div>
    <TheMedia
      :title="title"
      :description="description"
      :video-data="videoData"
      :thumbnail="imageUrl"
      :has-arrow-button="true"
      class="aspect-video w-full rounded-3xl"
    />
  </div>
</template>

<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router';

  import type { IVideoData } from '@/components/Shared/Lightbox/Video.vue';
  import TheNuxtLink from '@/components/TheNuxtLink.vue';

  interface IProps {
    title: string;
    description: string;
    imageUrl: string;
    videoUrl?: string;
    buttonId?: string;
    buttonUrl?: RouteLocationRaw;
    buttonName?: string;
    clickable?: boolean;
    hasShadow?: boolean;
    hasMinHeight?: boolean;
  }

  const props = withDefaults(defineProps<IProps>(), {
    videoUrl: undefined,
    buttonId: undefined,
    buttonUrl: undefined,
    buttonName: undefined,
    clickable: false,
    hasShadow: true,
    hasMinHeight: true,
  });

  const videoData = computed((): IVideoData | undefined =>
    props.videoUrl
      ? {
          title: props.title,
          description: props.description,
          url: props.videoUrl,
          imageUrl: props.imageUrl,
          buttonPosition: 'center',
        }
      : undefined
  );

  const linkRef = ref<InstanceType<typeof TheNuxtLink> | null>(null);

  const handleClick = (event: MouseEvent): void => {
    const linkEl = linkRef.value?.$el as HTMLElement | undefined;
    const isOutsideLink = linkEl && !linkEl.contains(event.target as Node);
    // 避免點擊連結本身時再次觸發，造成無窮迴圈
    if (props.clickable && props.buttonUrl && isOutsideLink) {
      linkEl.click();
    }
  };
</script>
